<template>
  <div class="position-relative">
    <input type="text" class="form-control" :placeholder="placeholder" :value="value"
      @input="onInput($event.target.value)" @focus="showDropdown = true" @blur="onBlur" :required="required"
      :maxlength="maxlength" />

    <div v-if="loading"
      class="position-absolute end-0 top-50 translate-middle-y me-3 spinner-border spinner-border-sm text-secondary"
      role="status"></div>

    <ul v-if="showDropdown && results.length > 0" class="dropdown-menu show w-100 shadow-sm overflow-auto"
      style="max-height: 200px; z-index: 1050;">
      <li v-for="(res, i) in results" :key="i">
        <a class="dropdown-menu-item dropdown-item text-wrap py-2 cursor-pointer" href="#"
          @mousedown.prevent="selectItem(res)">
          <strong>{{ res.code }}</strong> - {{ res.text }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import commons from '../../commons';

export default {
  name: 'AutocompleteInput',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    required: { type: Boolean, default: false },
    maxlength: { type: [String, Number], default: '' },
    apiUrl: { type: String, required: true } // Ruta de tu API backend
  },
  data() {
    return {
      results: [],
      loading: false,
      showDropdown: false,
      timeout: null
    };
  },
  methods: {
    onInput(val) {
      this.$emit('input', val);

      console.log("Input value:", val); // Debug: Verificar el valor del input
      console.log("API URL:", this.apiUrl); // Debug: Verificar la URL de la API
      clearTimeout(this.timeout);
      if (!val || val.trim().length < 2) {
        this.results = [];
        return;
      }

      this.timeout = setTimeout(() => {
        this.fetchData(val);
      }, 350);
    },
    async fetchData(query) {
      this.loading = true;
      try {
        const response = await fetch(`${commons.apiURL}${this.apiUrl}?search=${encodeURIComponent(query)}`);
        const json = await response.json();

        if (json.OK && Array.isArray(json.data)) {
          this.results = json.data.map(item => ({
            code: item.c_ClaveProdServ || item.clave,
            text: item.Descripción || item.descripcion || item.nombre,
            raw: item
          }));
        } else {
          this.results = [];
        }
      } catch (error) {
        console.error("Error cargando autocomplete:", error);
        this.results = [];
      } finally {
        this.loading = false;
      }
    },
    selectItem(item) {
      this.showDropdown = false;
      this.$emit('select', item);
    },
    onBlur() {
      setTimeout(() => { this.showDropdown = false; }, 200);
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.dropdown-menu-item:hover {
  background-color: #f8f9fa;
}

.end-0 {
  right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SAT/AutocompleteInput.vue